import { api } from "~/utils/api";
import { onErrorToast } from "~/utils/api-errors";

export const useEndImpersonation = () => {
  const apiRoutes = api.useUtils();
  return api.admin.endImpersonation.useMutation({
    onError: onErrorToast,
    onSettled: () => apiRoutes.invalidate(),
  });
};

export const useCreateImpersonation = () => {
  const apiRoutes = api.useUtils();
  return api.admin.createImpersonation.useMutation({
    onError: onErrorToast,
    onSettled: () => apiRoutes.invalidate(),
  });
};
